import { render, staticRenderFns } from "./complaintsList.vue?vue&type=template&id=690f4baf&scoped=true&"
import script from "./complaintsList.vue?vue&type=script&lang=js&"
export * from "./complaintsList.vue?vue&type=script&lang=js&"
import style0 from "./complaintsList.vue?vue&type=style&index=0&id=690f4baf&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690f4baf",
  null
  
)

export default component.exports